"use client";

/**
 * Precio con descuento de distribuidor: muestra el precio normal tachado y
 * al lado el precio con el descuento aplicado. Sin descuento (cliente
 * normal) muestra solo el precio.
 */

export function conDescuento(precio: number, descuento: number): number {
  return Math.round(precio * (1 - descuento) * 100) / 100;
}

export function PrecioDist({
  precio,
  descuento,
  className = "",
  claseTachado = "",
}: {
  precio: number | null;
  /** Fracción 0..1 (0.18 = 18%). */
  descuento: number;
  className?: string;
  claseTachado?: string;
}) {
  if (precio === null) return <span className={className}>Consultar</span>;
  if (descuento <= 0) {
    return <span className={className}>${precio.toFixed(2)}</span>;
  }
  return (
    <span className={className}>
      <span className={`font-normal text-tinta/45 line-through ${claseTachado}`}>
        ${precio.toFixed(2)}
      </span>{" "}
      <span className="text-verde">${conDescuento(precio, descuento).toFixed(2)}</span>
    </span>
  );
}
